module.exports = __webpack_public_path__ + "static/media/Linkedinwithround.0e348b2b.svg";